import * as prelude from '#gleam/prelude'

export function renderHtmlText(content: string) {
  const dom = new DOMParser().parseFromString(content, 'text/html')
  const text = dom.body.textContent
  if (!text) return new prelude.Error(undefined)
  return new prelude.Ok(text)
}
